export default function getFullName(profile) {
    if (profile.first_name !== "") {
        return (profile.first_name || "") + " " + (profile.last_name || '');
    } else {
        return "";
    }
}